module.exports = __webpack_public_path__ + "img/1507536196.3cb8ed7a.jpg";